import { render, staticRenderFns } from "./DepositDetailWS.vue?vue&type=template&id=424e9453&scoped=true"
import script from "./DepositDetailWS.vue?vue&type=script&lang=js"
export * from "./DepositDetailWS.vue?vue&type=script&lang=js"
import style0 from "./DepositDetailWS.vue?vue&type=style&index=0&id=424e9453&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424e9453",
  null
  
)

export default component.exports